import { Injectable } from '@angular/core';

import { ProductSampleSpec } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductSampleSpecService extends TmsWebBaseEditService<ProductSampleSpec, ProductSampleSpec> {
  constructor() {
    super('SampleSpec', $localize`Sample Spec`);
  }
}
